import * as Yup from 'yup'

export const articleHeadingSchemaValidation = Yup.object().shape({
  content: Yup.object().shape({
    title: Yup.string().trim().max(200).required().label('Title'),
    author: Yup.string().trim().max(200).required().label('Author'),
    caption: Yup.string().trim().max(200).nullable().label('Caption'),
  }),
})
